var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('v-btn',{attrs:{"disabled":!_vm.canUseCalendar,"color":_vm.color,"icon":""},on:{"click":function($event){return _vm.onClickCalendar()}}},[_c('v-icon',[_vm._v("$calendar")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }